<template>
	<div class="form-group">
		<label v-if="field.question">{{ field.question }}</label>
		<div v-if="field.description" v-html="field.description"></div>
		<VueSignaturePad 
		width="100%" 
		height="500px" 
		ref="signaturePad" 
		style="border:1px solid black; max-width: 800px;" 
		:options="{ onBegin, onEnd }"
		/>
		<button class="btn btn-light mt-2" @click="clear" v-if="!readonly">{{$t('clear')}}</button>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly'],
	methods: {
		clear() {
			this.$refs.signaturePad.clearSignature();
			this.field.value = null;
		},
	    onBegin() {
	    },
	    onEnd() {
			const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			if(!isEmpty) {
				this.field.value = data;
			}
	    }
	},
	watch: {
		readonly: function () {
			if(this.readonly) {
				this.$refs.signaturePad.lockSignaturePad();
			} else {
				this.$refs.signaturePad.openSignaturePad();
			}
		}
	},	
	mounted() {
		if(this.field.value) {
			this.$refs.signaturePad.fromDataURL(this.field.value)
		}
		if(this.readonly) {
			this.$refs.signaturePad.lockSignaturePad();
		} else {
			this.$refs.signaturePad.openSignaturePad();
		}		
	}
};
</script>
